module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/offline-database-4.9515a77a.svg";